import { FormControl, FormField, FormItem, FormLabel } from "@/components/ui/form"
import { Input } from "@/components/ui/input"
import { useTranslations } from "next-intl"

interface ContactStoreFieldProps {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  form: any
  label?: string | null
  required?: boolean
}

const ContactStoreField = ({ form, label, required = true }: ContactStoreFieldProps) => {
  const t = useTranslations("ContactForm")
  const displayLabel = (label?.trim()) || t("storeName")

  return (
    <FormField
      control={form.control}
      name="storeName"
      rules={{ required: required ? t("storeNameRequired") : false }}
      render={({ field }) => (
        <FormItem className="space-y-2">
          <FormLabel htmlFor="storeName">{displayLabel}</FormLabel>
          <FormControl>
            <Input
              id="storeName"
              className="glass-panel"
              {...field}
            />
          </FormControl>
        </FormItem>
      )}
    />
  )
}

export default ContactStoreField